<template>
  <div>
    <general-top-bar :title="$t('reports.operatorSalesReport')"></general-top-bar>
    <div class="sales-report">
      <div class="row mar-bt-15">
        <div class="col-md-6">
          <div class="mb-3 w-100" v-if="showLocations">
            <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control mar-bt-15" v-model="orders.location">
              <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <template v-for="loc in locations">
                <option :label="loc.name" :value="loc.id">{{loc.name}}</option>
              </template>
            </select>
          </div>

          <div class="mb-3 w-100" v-if="posUsers">
            <label class="form-label text-start w-100">{{$t('reports.operator')}}</label>
            <v-select
              v-model="selectedPosUser"
              :options="posUsers"
              multiple
              :placeholder="$t('general.alls')"
            ></v-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="center-sales-report-stats" style="height: 225px !important;">
            <div class="card-content" v-loading="loading">
              <!-- <div class="report-container"> -->
                <div class="report-row slim">
                  <div class="report-col left-align">{{$t('reports.orderCounter')}}</div>
                  <div class="report-col right-align">{{Number(productsTableDataTotals.counter || 0)}}</div>
                </div>
                <div class="report-row slim">
                  <div class="report-col left-align">{{$t('reports.salesChart')}}</div>
                  <div class="report-col right-align">{{formatMoneyAmount(Number(productsTableDataTotals.total || 0))}}</div>
                </div>
                <div class="report-row slim">
                  <div class="report-col left-align">{{$t('reports.discount')}}</div>
                  <div class="report-col right-align">{{formatMoneyAmount(Number(productsTableDataTotals.discount || 0))}}</div>
                </div>
                <div class="report-row slim">
                  <div class="report-col left-align">{{$t('reports.tips')}}</div>
                  <div class="report-col right-align">{{formatMoneyAmount(Number(productsTableDataTotals.tips || 0))}}</div>
                </div>
                <div class="report-row slim">
                  <div class="report-col left-align">{{$t('reports.protocol')}}</div>
                  <div class="report-col right-align">{{formatMoneyAmount(Number(productsTableDataTotals.total_protocol || 0))}}</div>
                </div>
                <div class="report-row slim">
                  <div class="report-col left-align">{{$t('reports.staffFood')}}</div>
                  <div class="report-col right-align">{{formatMoneyAmount(Number(productsTableDataTotals.total_staff_food || 0))}}</div>
                </div>
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <p class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>
          <div class="pull-left" 
            style="display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 10px;"
          >
            {{$t('general.from')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_from"
              v-model="valid_from"
               style="margin-left: 10px;"
              :change="changeValidFrom()"
              class="mar-rt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
            {{$t('general.to')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_to"
              v-model="valid_to"
              :change="changeValidFrom()"
              class="mar-lt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
          </div>
        </p>
        <div class="pull-left search-button-reports">
          <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
        </div>
        <div class="search-button-reports form-group pull-left">
          <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="exportData()">{{$t('general.download_xls') }} <img src="/static/img/export_xls.png"></div>
        </div>
      </div>
      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;">{{ $t('reports.filteredData') }} <b>{{orders.valid[0]}} {{valid_from}}:00</b> - <b>{{orders.valid[1]}} {{valid_to}}:59</b></p>
      </div>

      <div class="col-md-12">
        <div class="card-content total-pagination reports-center-columns">
          <chart-bars-card
            v-loading="loading"
            :chart-data="topProductSales.data"
            :chart-options="topProductSales.options"
            ref="topProductSales"
          >
            <template v-if="noData">
              <div class="no-data-message" style="text-align: center; margin: 20px;">
                <h3>{{ $t('reports.noDataAvailable') }}</h3>
              </div>
            </template>
            <div slot="header">
            </div>
            
            <div slot="footer">
              <div class="chart-legend" style="display: flex; flex-wrap: wrap;">
                <div
                  v-for="(label, index) in topProductSales.data.labels"
                  :key="index"
                  style="display: flex; align-items: center; margin-right: 12px;"
                >
                  <i
                    class="fa fa-circle"
                    :style="{ color: colors[index % colors.length], marginRight: '5px' }"
                  ></i>
                  <span>{{ label }} - {{ topProductSales.data.series[0][index] }}</span>
                </div>
              </div>
            </div>
          </chart-bars-card>
        </div>
      </div>

      <div class="col-md-12" style="margin-top: 15px;">
        <data-tables-server
          v-loading="loading"
          :data="ordersTableData.data"
          :search-def="{show: false}"
          @query-change="paginationChanged"
          :total="ordersTableData.total"
          :pagination-props="paginationProps"
          class="report-sales"
          key="sales-table"
          style="width: 100%"
          ref="reportsTable">
            <el-table-column class-name="centered-cell" :min-width="80" prop="operator_name" :label="$t('reports.name')"/>
            <el-table-column class-name="centered-cell" :min-width="80" prop="counter" :label="$t('reports.countProtocolStaff')">
              <template slot-scope="props">
                {{ Number(props.row.counter) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="total" :label="$t('reports.salesProtocolStaff')">
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total)) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="count_protocol" :label="$t('reports.countProtocol')">
              <template slot-scope="props">
                {{ Number(props.row.count_protocol) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="total_protocol" :label="$t('reports.salesProtocol')">
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_protocol)) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="count_staff_food" :label="$t('reports.countStaff')">
              <template slot-scope="props">
                {{ Number(props.row.count_staff_food) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="total_staff_food" :label="$t('reports.salesStaff')">
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_staff_food)) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="combined_discount" :label="$t('reports.discount')">
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.combined_discount)) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="total_tips" :label="$t('reports.tips')">
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_tips)) }}
              </template>
            </el-table-column>
        </data-tables-server>
      </div>
    </div>
  </div>
</template>

<script>
import {DatePicker} from 'element-ui'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
import ChartPieCard from 'src/components/UIComponents/Cards/ChartPieCard.vue'
import moment from 'moment'
import swal from 'sweetalert2'
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import SearchableMultiSelect from 'src/components/UIComponents/Inputs/SearchableMultiSelect.vue'

export default {
  components: {
    GeneralTopBar,
    SearchableMultiSelect,
    [DatePicker.name]: DatePicker,
    ChartCard,
    ChartBarsCard,
    ChartPieCard
  },
  props: {
    isOperatorSales: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isOperatorSales () {
      if (this.isOperatorSales) {
        this.getOrders()
        this.verifyUserLocations()
        this.verifyUserMethods()
        this.getPosUsers()
      }
    }
  },
  computed: {
    posUsers () {
      return this.rawPosUsers.map(user => ({
        value: user.id,
        label: `${user.firstname} ${user.lastname}`
      }))
    }
  },
  // created () {
  //   this.getOrders()
  //   this.verifyUserLocations()
  //   this.verifyUserMethods()
  //   this.getPosUsers()
  // },
  data () {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      selectedCategories: [],
      selectedTopCategories: [],
      rawPosUsers: [],
      ordersTableData: {},
      productsTableDataTotals: {},
      selectedPosUser: null,
      topProductSales: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          showArea: true,
          height: '500px',
          axisX: {
            scaleMinSpace: 50,
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      loading: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [
          moment().date(1).format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      },
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      colors: [
        '#f44336', // red
        '#2196f3', // blue
        // '#4caf50', // green
        '#ff9800', // orange
        '#9c27b0', // purple
        '#00bcd4', // cyan
        // '#e91e63', // pink
        '#8bc34a', // light green
        '#ffc107', // amber
        '#3f51b5', // indigo
        '#ff5722', // deep orange
        '#795548', // brown
        '#607d8b', // blue grey
        '#009688', // teal
        '#cddc39', // lime
        '#673ab7', // deep purple
        '#03a9f4', // light blue
        '#aed581', // soft green
        '#ffb74d', // soft orange
        '#ba68c8'  // soft purple
      ],
      noData: false
    }
  },
  methods: {
    changeValidFrom () {
      if (!this.valid_from) {
        this.valid_from = '00:00'
      }
      if (!this.valid_to) {
        this.valid_to = '23:59'
      }
    },
    paginationChanged (query) {
      if (query.type === 'page') this.getOrders(query)
      if (query.type === 'size') this.getOrders(query)
      if (query.type === 'sort') this.getOrders(query)
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
        id: location.true_id,
        name: location.name
      }))

      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))
        console.log(allowedLocations)
        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }

      if (this.locations.length > 1) {
        this.showLocations = true
      }

      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.orders.location = filterCookie[0]
      }
    },
    verifyUserMethods () {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels
      this.showMethods = true
    },
    getOrders (query) {
      if (!this.isOperatorSales) {
        return
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }
      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: this.orders.valid[0],
        to_date: this.orders.valid[1]
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      if (this.selectedPosUser && this.selectedPosUser.length) {
        data.operator_ids = this.selectedPosUser.map(element => { return element.value })
      }

      this.loading = true
      const pageSize = query ? query.pageSize : 20
      const page = query ? query.page : 1

      this.apiRequest('/reports/v2/operator' + '?page=' + page + '&perPage=' + pageSize, 'GET', data, response => {
        if (response.status) {
          this.productsTableDataTotals = response.totals
          if (response.data.table_data.length) {
            this.ordersTableData.data = response.data.table_data
            this.ordersTableData.total = response.pagination.total
            this.paginationProps.currentPage = response.pagination.page
            this.paginationProps.pageSize = response.pagination.perPage
          } else {
            this.ordersTableData.data = []
            this.ordersTableData.total = 0
            this.paginationProps.currentPage = 1
            this.paginationProps.pageSize = 20
          }

          this.topProductSales.options.chartPadding = {
            top: 30,
            right: 10,
            bottom: 20,
            left: 20
          }

          if (!response.data.labels.length) {
            this.$nextTick(() => {
              this.topProductSales.data.labels = []
              this.topProductSales.data.series = [[]]
              this.noData = true

              if (this.$refs.topProductSales.chart) {
                this.$refs.topProductSales.initChartAndReturn()
              }

              return false
            })
          }

          this.noData = false
          this.topProductSales.data.labels = response.data.labels
          this.topProductSales.data.series = [response.data.series]

          this.$nextTick(() => {
            this.$refs.topProductSales.initChartAndReturn()

            if (this.$refs.topProductSales.chart) {
              this.$refs.topProductSales.chart.on('draw', data => {
                if (data.type === 'bar') {
                  data.element.attr({
                    style: `stroke: ${this.colors[data.index % this.colors.length]}; stroke-width: 60px;`
                  })
                }
              })
            }
          })
        } else {
          this.topProductSales.data.labels = []
          this.topProductSales.data.series = [[]]
          this.discounts = []
          this.noData = true

          if (this.$refs.topProductSales.chart) {
            this.$refs.topProductSales.initChartAndReturn()
          }

          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    updateData () {
      this.getOrders()
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    },
    exportData () {
      let fromDate = this.orders.valid[0]
      let toDate = this.orders.valid[1]

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      this.loading = true
      this.apiRequest('/reports/v2/operator-download', 'GET', data, response => {
        if (response.status === true) {
          const link = document.createElement('a')
          link.href = response.data.file
          link.setAttribute('download', response.data.file_name)
          document.body.appendChild(link)
          link.click()
        } else {
          swal(
            '',
            this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.loading = false
      })
    },
    getPosUsers () {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest('/pos/all/users', 'GET', data, (response) => {
        if (response.status) {
          this.rawPosUsers = response.data.pos_user
        }
      })
    }
  }
}
</script>
<style>
  .ct-label {
    display: none;
  }
  .ct-legend-inside .inactive {
    opacity: 0.3;
  }
  .cell b {
    word-break: break-word;
  }
  .card .details h6 {
    text-align: left;
    font-weight: 500;
  }
  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 70px;
  }
  .report-row slim {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .sales-report .sales-height .card {
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
  .sales-report .sales-height:nth-child(1) .card {
    align-items: center;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 650px;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }
  /* .ct-label.ct-horizontal {
    white-space: pre-line;
    text-anchor: middle;
    font-size: 12px;
  } */
  .ct-label.ct-horizontal {
    font-size: 12px !important;
    text-anchor: middle !important;
  }
  foreignObject div {
    font-size: 12px;
    line-height: 1.2em;
    text-align: center;
    color: #333;
  }

  .ct-label .ct-vertical {
    font-size: 12px;
    overflow: visible !important;
  }

  /* .ct-chart {
    overflow: visible !important;
  } */

  .ct-chart {
    padding-top: 20px; /* or more */
    overflow: visible !important;
  }

  .slim {
    margin-bottom: 10px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/OperatorSalesReport.vue